// extracted by mini-css-extract-plugin
var _1 = "gGTk1LzvN9o3oaKbBcJJ";
var _2 = "YP7dolpJacapgWGA4IMC";
var _3 = "poxQ0Do602efftTcq3jH";
export { _1 as "heartbeat-colors", _2 as "hover", _3 as "logo" }
